import { UseGlobalLoading } from "Hooks/UseGlobalLoading";

import Button from "Components/Admin/Buttons";
import Table from "Components/Admin/Table";

import * as S from "./styles";

const ProjectsSearch = ({
  projects,
  selectedProjects,
  setSelectedProjects,
  getProjects,
  setProjects,
}) => {
  const { loading } = UseGlobalLoading();

  const searchProjects = async () => {
    setProjects([]);
    await getProjects(setProjects, selectedProjects);
  };

  const columns = [
    {
      Header: "Nome",
      accessor: "project_name",
    },
  ];

  const defaultSelectedRows = (state) => {
    const obj = {};

    for (let i = 0; i < state.length; i++) {
      obj[i] = true;
    }

    return obj;
  };

  const onSelectChange = (selected) => {
    setSelectedProjects(selected);
  };

  return (
    <S.Wrapper>
      <S.FormWrapper>
        <h1>Projetos</h1>
        <Button
          type="button"
          text="Buscar"
          onClick={searchProjects}
          disabled={loading}
        />
      </S.FormWrapper>

      {projects.length > 0 && (
        <S.Table>
          <Table
            defaultSelectedRowIds={defaultSelectedRows(selectedProjects)}
            columns={columns}
            data={projects}
            download={false}
            selectable={true}
            onSelectChange={onSelectChange}
          />
        </S.Table>
      )}
    </S.Wrapper>
  );
};

export default ProjectsSearch;
